<template>
  <modal v-on:closeModalRequest="closeModalRequest()">
    <div class="modal-change-ip-user-name scrollable -y">
      <div class="header">
        <div class="title">Change Name</div>
      </div>
      <form
      v-on:submit="onClickSubmit"
      class="body">
        <div class="content">
          <div class="info-container">
            <div class="label">User name</div>
            <input id="first-name" type="text" v-model="firstName" ref="first-name">
          </div>
          <div class="action-btns">
            <input
            id="update-name"
            type="submit" value="Update"
            class="action-btn blue" />
            <div
            v-on:click="closeModalRequest()" ontouchstart=""
            class="action-btn">Cancel</div>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'modal-change-ip-user-name',
  components: {
    Modal
  },
  computed: {
    myFirstName: function () {
      return this.$store.getters.myFirstName
    }
  },
  data: function () {
    return {
      firstName: null
    }
  },
  created: function () {
    this.initInputs()
    this.setInputFocused()
  },
  methods: {
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
      setTimeout(() => { this.getMyProfile() }, 1000)
    },
    onClickSubmit: function (e) {
      e.preventDefault()
      this.updateMyProfile().then(
        success => {
          this.closeModalRequest()
        },
        failure => {
          this.closeModalRequest()
        }
      )
    },
    setInputFocused: function () {
      this.$nextTick(() => {
        if (this.$refs['first-name']) {
          this.$refs['first-name'].focus()
        } else {
          setTimeout(() => {
            if (this.$refs['first-name']) {
              this.$refs['first-name'].focus()
            }
          }, 1000)
        }
      })
    },
    initInputs: function () {
      this.firstName = this.myFirstName
    },
    getMyProfile: function () {
      return this.$store.dispatch('getMyProfile')
    },
    updateMyProfile: function () {
      let firstName = this.firstName
      let lastName = null
      return this.$store.dispatch('updateMyProfile', {firstName, lastName})
    }
  }
}
</script>

<style scoped>
.modal-change-ip-user-name {
  /* common */
  background-color: hsla(0, 100%, 100%, 1);
  border-radius: 5px;
  /* size */
  max-width: 500px;
  max-height: 100%;
  width: 100%;
}

.modal-change-ip-user-name .header {
  /* common */
  font-size: 14px;
  /* size */
  padding: 20px 16px 20px;
  /* text */
  font-weight: bold;
  /* alignment */
  text-align: left;
}
.modal-change-ip-user-name .header .title {
  /* common */
  font-size: 2em;
}
.modal-change-ip-user-name .header .description {
  /* common */
  font-size: 1em;
  /* text */
  font-weight: normal;
}


.modal-change-ip-user-name .body {
  /* size */
  padding: 0 16px;
  /* border */
  border-top: 1px solid hsla(0, 100%, 0%, 0.1);
  /* alignment */
  text-align: left;
}

.modal-change-ip-user-name .body .content {
  /* common */
  color: #000;
  font-size: 16px;
  /* size */
  width: 100%;
  min-height: 4em;
  margin: 16px 0;
  /* border */
  /* outline: 1px solid red; */
}


.modal-change-ip-user-name .body .content .info-container:first-child {
  margin-top: 0;
}
.modal-change-ip-user-name .body .content .info-container {
  /* size */
  margin: 1em 0;
}
.modal-change-ip-user-name .body .content .info-container > input {
  /* common */
  background-color: hsla(0, 100%, 0%, 0.1);
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
}





.modal-change-ip-user-name .body .content .action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal/ModalChangeIpUserName.vue